/**
 * Determine if the given string is a valid URL.
 *
 * @param value The string to test.
 * @param allowedProtocols Optional list of allowed protocols.
 * @returns True if the string is a valid URL.
 */
export function isURL(
  value: string,
  allowedProtocols: string[] = ['http:', 'https:']
): boolean {
  if (!value || typeof value !== 'string') return false;

  try {
    const url = new URL(value);
    return allowedProtocols.includes(url.protocol);
  } catch {
    return false;
  }
}
